let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("Ez77u")).then(() => parcelRequire('KWDla'));